<template>
  <button
    :type="buttonType"
    :disabled="isDisabled"
    :class="`hover:bg-red-secondary transform select-none items-center rounded bg-red-primary px-4 py-3 text-min text-white shadow-sm hover:-translate-y-0.5 active:bg-red-primary disabled:cursor-not-allowed ${classes}`"
    @click="$emit('click')"
    @submit="$emit('submit')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'DestructivePrimaryButton',

  props: {
    buttonType: {
      type: String,
      default: 'button',
    },
    classes: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click', 'submit'],

  data() {
    return {
      isDisabled: this.disabled,
    }
  },

  watch: {
    disabled(newValue) {
      this.isDisabled = newValue
    },
  },
}
</script>
